// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"421":"0f678440","581":"1555d2bf","676":"78471ed1","878":"ed55d602"}[chunkId] + ".chunk.js";
};